/**
 * TrustGate Console - Badge Component
 * Status badges with color coding
 * 
 * Uses canonical status system from shared/status.ts
 */

import React from 'react';
import { getStatusMeta } from '../../shared/status';

interface BadgeProps {
  status: string;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ status, className = '' }) => {
  const meta = getStatusMeta(status);

  return (
    <span 
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${meta.bgColor} ${meta.borderColor} ${className}`}
      style={{ color: meta.color }}
    >
      <span>{meta.icon}</span>
      <span>{meta.label}</span>
    </span>
  );
};
